import { TFunction } from 'i18next';
import { number, object, string } from 'yup';

export const studioValidationScheme = (t: TFunction) => {
  const getMessage = (field: string) => t('form.field.message.required', { field });
  const error = {
    required: {
      name: getMessage(t('form.field.name')),
      countryName: getMessage(t('form.field.location.country')),
      category: getMessage(t('event.sportCategory')),
      city: getMessage(t('form.field.location.city')),
      street: getMessage(t('form.field.location.street')),
    },
  };

  return object({
    name: string().required(error.required.name),
    countryName: string().required(error.required.countryName),
    category: number().min(1, error.required.category).required(error.required.category),
    city: string().required(error.required.city),
    street: string().required(error.required.street),
  });
};
